/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";
import "@/assets/tailwind/tailwind.css";
import "@/assets/vuexy/main.scss";
import "@/assets/scss/Index.scss";
import FeatherIcon from "./components/FeatherIcon.vue";
// Vuesax Component Framework
import Vuesax from "vuesax";
import "element-ui/lib/theme-chalk/index.css";

import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
// import firebaseInstance from "@/Firebase/firebase";
import VueEllipseProgress from "vue-ellipse-progress";
import CircularCountDownTimer from "vue-circular-count-down-timer";
import Tooltip from "vue-directive-tooltip";
import "vue-directive-tooltip/dist/vueDirectiveTooltip.css";

Vue.use(Tooltip);

Vue.use(CircularCountDownTimer);
Vue.use(VueEllipseProgress, "vep");

Vue.use(Vuesax);
import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment,
});
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.prototype.$community = process.env.VUE_APP_COMMUNITY_NAME;
Vue.prototype.$imageURL = `${process.env.VUE_APP_IMAGE_URL}`;

//forback
Vue.mixin({
  methods: {
    handleBack: function () {
      this.$router.go(-1);
    },
  },
});

// Theme Configurations
import "../themeConfig";

// Vue Router
import router from "./router/index";

// Vuex Store
import store from "./store/store";

// Tour
import VueTour from "vue-tour";
Vue.use(VueTour);
require("vue-tour/dist/vue-tour.css");

// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate, { events: "change|blur" });

import VueSocketIO from "vue-socket.io";
import SocketIO from "socket.io-client";

Vue.use(
  new VueSocketIO({
    debug: true,
    // connection: SocketIO("http://localhost:3001/", {
    //   transports: ["websocket"],
    // }),
    connection: SocketIO(process.env.VUE_APP_WHATSAPP_URL, {
      transports: ["websocket"],
    }),
  })
);

// Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: "YOUR_API_KEY",
    libraries: "places", // This is required if you use the Auto complete plug-in
  },
});

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

Vue.use(VueSweetalert2);

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// ########################## Admin ##########################
import ElementUI from "element-ui";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
Vue.use(ElementUI);
locale.use(lang);

// ..
// import "./argon/scss/argon.scss"; //affecting css
export const EventBus = new Vue();
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
